module.exports = __webpack_public_path__ + "media/assets/icon-sorting-f1c22eca4faf1fa94daedc17e3e99883258687f6785201f34e89688f993d8b9e.png";